import type { FC, ReactNode } from "react";
import { cn } from "@/lib/cn";

type IconTextProps = {
  icon: ReactNode;
  children: ReactNode;
  underline?: boolean;
  className?: string;
  contentClassName?: string;
};

export const IconText: FC<IconTextProps> = ({ icon, children, underline, className, contentClassName }) => (
  <span className={cn("inline-flex items-center gap-8 text-14 text-neutral-black", className)}>
    <span className="shrink-0">{icon}</span>
    <span className={cn(underline && "underline decoration-dotted underline-offset-2", contentClassName)}>
      {children}
    </span>
  </span>
);
